import type { AxiosRequestConfig } from 'axios';
import { put, takeLatest } from 'redux-saga/effects';

import { fetchPage } from 'modules/app/sagas/resolveAll';
import type { ApiError, PageContent } from 'modules/global/generic.types';

import * as brandingTemplatesActions from './actions';
import * as types from './actionTypes';
import type { BrandingTemplate, FetchBrandingTemplatesRequestAction } from './types';

function* fetchBrandingTemplatesWorker(action: FetchBrandingTemplatesRequestAction) {
  const { request } = action.payload;

  try {
    const data: PageContent<BrandingTemplate> = yield* fetchPage<BrandingTemplate>(request as AxiosRequestConfig);
    yield put(brandingTemplatesActions.fetchBrandingTemplatesSuccess(data, action.meta));
  } catch (error) {
    yield put(brandingTemplatesActions.fetchBrandingTemplatesFailure(error as ApiError, action.meta));
  }
}

export default function* brandingTemplatesSagas() {
  yield takeLatest(types.FETCH_BRANDING_TEMPLATES_REQUEST, fetchBrandingTemplatesWorker);
}
